import './App.css';

function App() {
    const openCalendly = () => {
        const url = 'https://calendly.com/patrick-kellyse/30min';
        if (typeof window !== 'undefined' && window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
            window.Calendly.initPopupWidget({ url });
        } else {
            window.open(url, '_blank', 'noopener');
        }
    };
    return (
    <>
        <div className="container">
            <div id="header">
                <h1>Patrick Kelly</h1>
                <p className="contact-info">Email: patrick.kelly@kuscko.com | Phone: +1 (727) 364-4111 | LinkedIn: linkedin.com/in/kuscko | GitHub: github.com/kuscko</p>
                <div className="header-actions">
                    <button className="action-button calendly-btn" onClick={openCalendly}>Schedule a Call</button>
                    <button className="action-button print-btn" onClick={() => window.print()}>Print</button>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="main-content">
                    <section id="skills-section">
                        <h2>SKILLS</h2>
                        <p><strong>Languages:</strong> Python, C#, JavaScript, SQL, Java, HTML, CSS, C++, C</p>
                        <p><strong>Frameworks:</strong> .NET Framework, .NET Core, .NET Standard, Angular.JS, ASP.NET, ASP.NET Core, Bootstrap, Django, Entity Framework, jQuery, Material UI, React, React Native, Tailwind CSS, UWP, WinForms, Webpack, Xamarin</p>
                        <p><strong>Tools:</strong> AWS SDK, Azure DevOps, Docker, Docker Compose, Git, Jenkins, MSTest, NPM, NuGet, Pip, RabbitMQ, Redis, RESTful APIs, OAuth2, WebSockets, Windows Services, xUnit, Azure, AWS, Google Cloud, Kubernetes, PostgreSQL, SQL Server, Linux, Windows Server</p>
                    </section>

                    <section id="experience-section">
                        <h2>EXPERIENCE</h2>
                        <div className="experience-item">
                            <h3>Senior Software Engineer - Babel Street Data</h3>
                            <p className="exp-date">Oct 2024 - Present</p>
                                <ul>
                                    <li>Architected and delivered high-performance applications using modern frameworks, improving scalability, resilience, and time-to-market.</li>
                                    <li>Designed microservices architectures and shipped RESTful APIs, enabling seamless integration and decoupled service ownership across teams.</li>
                                    <li>Provisioned and operated containerized infrastructure (Docker/Kubernetes) with automated CI/CD pipelines for repeatable, low-risk deployments.</li>
                                    <li>Built internal services and automation (Python/Django) to streamline data ingestion, ETL workflows, and platform operations.</li>
                                    <li>Monitored and optimized system performance via metrics, profiling, and tuning, proactively removing bottlenecks before they impacted users.</li>
                                    <li>Led Agile ceremonies (planning, grooming, retros, reviews) to deliver iterative product improvements and maintain predictable velocity.</li>
                                    <li>Mentored engineers, fostered knowledge sharing, and cultivated a culture of continuous learning and technical excellence.</li>
                                </ul>
                        </div>

                        <div className="experience-item">
                            <h3>Lead Platform Engineer - Babel Street Data</h3>
                            <p className="exp-date">Jan 2023 - Oct 2024</p>
                            <ul>
                                <li>Led and mentored a team of engineers, promoting high performance and professional growth.</li>
                                <li>Oversaw Python/Django service deployments across multiple environments while enforcing best practices for maintainability and performance.</li>
                                <li>Defined platform standards for logging, observability, and incident response; improved MTTR via actionable dashboards and alerts.</li>
                                <li>Optimized CI/CD pipelines with parallel jobs, artifact caching, and environment gating to reduce release time and increase deployment reliability.</li>
                                <li>Hardened infrastructure security through secret management, least-privilege IAM policies, and automated vulnerability scanning in the SDLC.</li>
                                <li>Implemented cost-aware scaling and capacity planning for containerized workloads, improving resource utilization across staging and production.</li>
                            </ul>
                        </div>

                        <div className="experience-item">
                            <h3>Software Engineer II - Babel Street Data</h3>
                            <p className="exp-date">Feb 2022 - Jan 2023</p>
                            <ul>
                                <li>Designed, coded, and debugged applications across multiple languages, improving feature delivery and system reliability.</li>
                                <li>Performed comprehensive analysis (requirements, code, reviews) to ensure software quality and operational efficiency.</li>
                                <li>Implemented modeling and simulation techniques to predict performance and optimize application behavior.</li>
                                <li>Led front-end interface design, elevating usability and user engagement through responsive UX patterns.</li>
                                <li>Managed testing and QA processes, stabilizing releases and reducing regressions through systematic validation.</li>
                            </ul>
                        </div>

                        <div className="experience-item">
                            <h3>Software Engineer - Telesmatic Systems LLC</h3>
                            <p className="exp-date">Mar 2020 - Jan 2022</p>
                            <ul>
                                <li>Collaborated on full-stack development of authoring software using React, .NET, and Python-Django frameworks.</li>
                                <li>Engineered complex data structures with Django/EF ORM and SQL/noSQL databases for robust data management.</li>
                                <li>Designed and configured CI/CD pipelines to streamline development workflow and release cycles.</li>
                                <li>Developed a 3D area within the Lost Souls MUD game world using the LPC programming language with intricate game logic.</li>
                            </ul>
                        </div>
                        <div className="experience-item">
                            <h3>Software Engineer - Proforma</h3>
                            <p className="exp-date">Mar 2019 - Jul 2020</p>
                            <ul>
                                <li>Prepared and maintained comprehensive documentation for test cases to enhance team communication.</li>
                                <li>Spearheaded the implementation of a real-time test reporting system, boosting productivity.</li>
                                <li>Developed automated tests using C# .Net Core and Selenium, ensuring consistent quality assurance.</li>
                                <li>Mentored junior developers, fostering a collaborative and high-performing team environment.</li>
                            </ul>
                        </div>
                    </section>

                    <section id="education-section">
                        <h2>EDUCATION</h2>
                        <div className="education-item">
                            <p><strong>Bachelor of Applied Science - Management and Software Development</strong> - St. Petersburg College</p>
                        </div>
                        <div className="education-item">
                            <p><strong>Associates in Science - Computer Programming and Analysis</strong> - Pasco-Hernando State College</p>
                        </div>
                    </section>

                    <section id="projects-section">
                        <h2>PROJECTS</h2>
                        <div className="project-item">
                            <h3>StateLink - Multi-Tenant CRM & Automation Platform</h3>
                            <ul>
                                <li>Developed a multi-tenant Django platform to ingest and normalize public business registry data at scale.</li>
                                <li>Built a CRM with custom tagging, filtering, and Kanban-style workflows for managing business records.</li>
                                <li>Automated templated document generation in PDF format, driven by CRM filters and status triggers.</li>
                                <li>Engineered secure, branded web portals to allow businesses to access and update relevant filings.</li>
                                <li>Achieved high performance and reliability: 99.5% uptime, less than 2s average query response time.</li>
                            </ul>
                        </div>

                        <div className="project-item">
                            <h3>SupplySage - Inventory Management System & POS</h3>
                            <ul>
                                <li>Architected a Django-based integrated inventory and point-of-sale platform with role-based access control, enabling real-time stock synchronization across sales channels and inventory management.</li>
                                <li>Engineered intelligent low-stock detection system with configurable thresholds and automated notifications, triggering purchase orders and alerts when inventory drops below critical levels.</li>
                                <li>Developed point-of-sale interface with transaction processing, item lookup, and payment integration, coupled with real-time inventory deduction for seamless sales operations.</li>
                                <li>Implemented comprehensive reporting system supporting sales analytics, inventory movement tracking, and PDF/CSV exports with templated report generation for data-driven business decisions.</li>
                            </ul>
                        </div>

                        <div className="project-item">
                            <h3>Django Web Project Template</h3>
                            <ul>
                                <li>Created a comprehensive Django web project template with user authentication and registration for engineers.</li>
                                <li>Designed solution architecture following SOLID design principles for scalable and maintainable code.</li>
                                <li>Implemented Django REST Framework for robust API development and backend services.</li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </>
    );
}

export default App;
